/**
 * Newsletter → Emarsys 同步
 * 拦截所有 Shopify {% form 'customer' %} 邮箱订阅表单，
 * 在正常提交流程之外，同步将邮箱推送到 Emarsys。
 *
 * 适配自 sm-nuxt3-website SubscribeBanner.vue 的提交逻辑，
 * 改为 Shopify 原生 JS 环境（无 Vue/框架依赖）。
 */

(function () {
  'use strict';

  /* ============================
   * 配置区（可按需修改）
   * ============================ */
  var EMARSYS_URL = 'https://suite46.emarsys.net/u/register.php';

  var EMARSYS_FIELDS = {
    CID: '883533479',      // Emarsys Contact List ID
    SID: '',
    UID: '',
    f: '783',               // Form ID
    p: '2',
    a: 'ccs',
    el: '',
    llid: '',
    c: '',
    counted: '',
    RID: '0',
    mailnow: '',
    optin: 'y'
  };

  /**
   * 根据 window.Domain 映射 Emarsys 站点“store_from” field的值
   * inp_15987: 1=global, 2=us, 3=eu, 4=other
   */
  const storeMap = {
    global: '1',
    us: '2',
    eu: '3'
  };
  /**
   * 根据 window.Domain 映射 Emarsys 站点"Locale" field的值
   * inp_8062: Global, United States, European Union, Official(这个代表官网，这里没用上)
   */
  const StoreEmarsysLocale = {
    global: 'Global',
    us: 'United States',
    eu: 'European Union'
  }

  // 根据店铺返回传到Emarsys的值，type为1时，返回inp_15987的对应值, 为其他值返回inp_8062的
  function getEmarsysValueByStore(type) {
    var domain = String(window.Domain || '').toLowerCase();
    // 回退：如果 window.Domain 不存在，根据 hostname 自行判断
    if (!domain || domain === 'test') {
      var hostname = window.location.hostname;
      if (hostname.indexOf('eu.snapmaker.com') > -1) {
        domain = 'eu';
      } else if (hostname.indexOf('us.snapmaker.com') > -1) {
        domain = 'us';
      } else if (hostname.indexOf('shop.snapmaker.com') > -1) {
        domain = 'global';
      }
    }
    return type == 1 ? (storeMap[domain] || '4') : (StoreEmarsysLocale[domain] || 'other');
  }

  /* ============================
   * 辅助函数
   * ============================ */

  /**
   * 构建 Emarsys 提交参数字段
   * @param {string} email
   * @returns {Object}
   */
  function buildEmarsysFields(email) {
    var fields = {};
    for (var key in EMARSYS_FIELDS) {
      if (EMARSYS_FIELDS.hasOwnProperty(key)) {
        fields[key] = EMARSYS_FIELDS[key];
      }
    }
    fields.inp_3 = email.trim();
    fields.inp_15987 = getEmarsysValueByStore(1);  // 区分站点：1=global, 2=us, 3=eu
    fields.inp_8062 = getEmarsysValueByStore(2);
    return fields;
  }

  /**
   * 通过隐藏 iframe + form 提交到 Emarsys（无页面跳转）
   * @param {string} email
   */
  function submitToEmarsys(email) {
    var iframe = document.createElement('iframe');
    var iframeName = 'emarsys-newsletter-' + Date.now();
    iframe.style.display = 'none';
    iframe.name = iframeName;
    document.body.appendChild(iframe);

    var hiddenForm = document.createElement('form');
    hiddenForm.method = 'GET';
    hiddenForm.action = EMARSYS_URL;
    hiddenForm.target = iframeName;
    hiddenForm.style.display = 'none';

    var fields = buildEmarsysFields(email);
    for (var name in fields) {
      if (fields.hasOwnProperty(name)) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = fields[name];
        hiddenForm.appendChild(input);
      }
    }

    document.body.appendChild(hiddenForm);
    hiddenForm.submit();

    // 5 秒后清理 DOM 节点
    setTimeout(function () {
      if (hiddenForm.parentNode) hiddenForm.parentNode.removeChild(hiddenForm);
      if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
    }, 5000);
  }

  /**
   * 判断表单是否为 newsletter / 邮箱订阅表单
   * @param {HTMLFormElement} form
   * @returns {boolean}
   */
  function isNewsletterForm(form) {
    // Shopify 所有 newsletter 订阅表单的特征：包含 name="contact[email]" 的 input
    return !!form.querySelector('input[name="contact[email]"]');
  }

  /* ============================
   * 全局拦截器（捕获阶段）
   * ============================ */
  document.addEventListener('submit', function (e) {
    var form = e.target;

    // 某些情况下 event.target 可能是表单内的按钮，向上查找 form
    if (!form || form.tagName !== 'FORM') {
      form = e.target.closest && e.target.closest('form');
      if (!form) return;
    }

    // 只处理 newsletter 订阅表单
    if (!isNewsletterForm(form)) return;

    // 提取邮箱
    var emailInput = form.querySelector('input[name="contact[email]"]');
    if (!emailInput) return;

    var email = (emailInput.value || '').trim();
    if (!email) return;

    // 并行推送到 Emarsys，不阻塞 Shopify 原生提交流程
    submitToEmarsys(email);
  }, true); // true = 捕获阶段，确保在其他 handler 之前执行
})();
